import fileToDataUrl from "./fileToDataUrl";

/**
 * Prepara un registro de picture para enviar a la API.
 * Si data es Blob, lo convierte a data URL; si ya es string, lo deja tal cual.
 * El sync (syncEventDataUp) usa este helper directamente porque no es un componente React.
 */
export default async function preparePictureForApi(picture) {
  if (!picture) return picture;
  if (picture.data instanceof Blob) {
    const dataUrl = await fileToDataUrl(picture.data);
    return { ...picture, data: dataUrl };
  }
  return picture;
}
